<template>
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class="login-card login-dark">
                    <div>
                        <div><router-link class="logo text-center" to="/"><img class="img-fluid for-light m-auto"
                                    src="@/assets/images/logo/logo1.png" alt="looginpage"><img
                                    class="img-fluid for-dark" src="@/assets/images/logo/logo-dark.png"
                                    alt="logo"></router-link></div>
                        <div class="login-main">
                            <form class="theme-form">
                                <h2 class="text-center">Create your account</h2>
                                <p class="text-center">Enter your personal details to create account</p>
                                <div class="form-group">
                                    <label class="col-form-label pt-0">Your Name</label>
                                    <div class="row g-2">
                                        <div class="col-6">
                                            <input v-model="form.firstname" class="form-control" type="text" required
                                                placeholder="First name">
                                        </div>
                                        <div class="col-6">
                                            <input v-model="form.lastname" class="form-control" type="text" required
                                                placeholder="Last name">
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-form-label">Email Address</label>
                                    <input v-model="form.email" class="form-control" type="email" required
                                        placeholder="********@gmail.com" :disabled="isExistMail">
                                </div>
                                <div class="form-group">
                                    <label class="col-form-label">Username</label>
                                    <input v-model="form.username" class="form-control" type="email" required
                                        placeholder="username">
                                </div>
                                <div class="form-group">
                                    <label class="col-form-label">Password</label>
                                    <div class="form-input position-relative">
                                        <input v-model="form.password" class="form-control" :type="type"
                                            name="login[password]" required placeholder="*********">
                                        <div class="show-hide"><span :class="type == 'password' ? 'show' : ''"
                                                @click="showPassword"></span></div>
                                    </div>
                                </div>
                                <div class="form-group mb-0 checkbox-checked">
                                    <!-- <div class="form-check checkbox-solid-info">
                                        <input class="form-check-input" id="solid6" type="checkbox">
                                        <label class="form-check-label" for="solid6">Agree with</label><router-link
                                            class="ms-3 link" to="/auth/forget_password">Privacy
                                            Policy</router-link>
                                    </div> -->
                                    <button @click="submit()" class="btn btn-primary btn-block w-100 mt-3"
                                        type="button">Create
                                        Account</button>
                                </div>
                                <!-- <div class="login-social-title">
                                    <h6>Or Sign in with </h6>
                                </div> -->
                                <!-- <div class="form-group">
                                    <ul class="login-social">
                                        <li><a href="https://www.linkedin.com" target="_blank"><i
                                                    class="icon-linkedin"></i></a></li>
                                        <li><a href="https://twitter.com" target="_blank"><i class="icon-twitter"></i></a>
                                        </li>
                                        <li><a href="https://www.facebook.com" target="_blank"><i
                                                    class="icon-facebook"></i></a></li>
                                        <li><a href="https://www.instagram.com" target="_blank"><i
                                                    class="icon-instagram"></i></a></li>
                                    </ul>
                                </div> -->
                                <p class="mt-4 mb-0 text-center">Already have an account?<router-link class="ms-2"
                                        to="/auth/login">Sign in</router-link></p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<style scoped>
.btn:disabled {
    background-color: #6c757d;
    border-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.65;
}

.form-control:disabled {
    background-color: #e9ecef;
    opacity: 1;
    cursor: not-allowed;
}
</style>
<script lang="ts" setup>
import { ref, onBeforeMount } from 'vue'
import { toast } from "vue3-toastify";
import { signupRequest } from "@/api/services/AuthRequest";
import * as parsing from '@/utils/parsing'
const type = ref<string>('password')
const isExistMail = ref<boolean>(false)
let form = {
    firstname: '',
    lastname: '',
    name: '',
    nickname: '',
    email: '',
    username: '',
    password: ''
}
onBeforeMount(async () => {
    const user = localStorage.getItem("user");
    if (user) {
        const userData = parsing.parseJson(user);
        form.name = `${userData.firstname} ${userData.lastname}`;
        form.nickname = `${userData.firstname} ${userData.lastname}`;
        form.firstname = userData.firstname;
        form.lastname = userData.lastname;
        form.email = userData.email;
        isExistMail.value = true
    }
})
function showPassword() {
    if (type.value === 'password') {
        type.value = 'text';
    } else {
        type.value = 'password';
    }
}
async function submit() {
    form.name = `${form.firstname} ${form.lastname}`;
    form.nickname = `${form.firstname} ${form.lastname}`;
    let resp = await signupRequest(form)
    if (resp.status == 200) {
        window.location.href = '/?token=' + resp.data
    } else {
        toast.error(resp.message, {
            position: "top-right",
            autoClose: 2000,
        });
    }
}
</script>